
import { RetailerKycDetailsType } from './retailer-kyc-details.type';
//add recharge section


export const setRegisterRetailerResponse = (data) => ({
  type: RetailerKycDetailsType.setRegisterRetailerResponse,
  payload: data

});
export const setPersonalInfo = (data) => ({
  type: RetailerKycDetailsType.setPersonalInfo,
  payload: data

});
export const setSaveData = (data) => ({
  type: RetailerKycDetailsType.setSaveData,
  payload: data

});
export const setROResponse = (data) => ({
  type: RetailerKycDetailsType.setROResponse,
  payload: data

});

export const setROId = (data) => ({
  type: RetailerKycDetailsType.setROId,
  payload: data

});


//biometric data
export const setBiometricDta = (data) => ({
  type: RetailerKycDetailsType.setBiometricDta,
  payload: data

});

export const setBiometricDtaCaptureStatus = (data) => ({
  type: RetailerKycDetailsType.setBiometricDtaCaptureStatus,
  payload: data

});

export const checkingDriverStatus = (data) => ({
  type: RetailerKycDetailsType.checkingDriverStatus,
  payload: data

});


export const setOnboardActiveRoId = (data) => ({
  type: RetailerKycDetailsType.setOnboardActiveRoId,
  payload: data

});


export const setOnboardResponse = (data) => ({
  type: RetailerKycDetailsType.setOnboardResponse,
  payload: data

});



export const setOnboardActiveRoIdMap = (data) => ({
  type: RetailerKycDetailsType.setOnboardActiveRoIdMap,
  payload: data

});

export const setMerchantOnboardStatus = (data) => ({
  type: RetailerKycDetailsType.setMerchantOnboardStatus,
  payload: data

});


export const resetRetailerKyc = {
  type: RetailerKycDetailsType.RESET
}